export enum DatePeriodEnum {
	Shift = 'Shift',
	Day = 'Day',
	Week = 'Week',
	Month = 'Month',
	Quarter = 'Quarter',
	Year = 'Year',
	Custom = 'Custom',
}
